import { createFileRoute } from '@tanstack/react-router'
import MigratePage from '../../Pages/MigratePage/MigratePage'
import PageBody from '../../Pages/Layout/PageBody'
import { canViewRoute } from '../../State/Permissions/HasPermissions'
import SessionStore from '../../State/SessionStore'
import PermissionDenied from '../../Pages/PermissionDenied'
import LoadingSpinner from '../../Components/LoadingSpinner'
import ErrorComponent from '../../Components/ErrorComponent'

export const Route = createFileRoute('/_private/migrate/$id')({
    beforeLoad: ({ params }) => {
        if (!canViewRoute(SessionStore.user, 'migrate', params))
            throw new Error('Permission Denied')
    },
    errorComponent: ({ error, reset }) => {
        if (error.message === 'Permission Denied') return <PermissionDenied />
        return <ErrorComponent error={error} reset={reset} />
    },
    component: Wrapper,
    pendingComponent: LoadingSpinner,
})

function Wrapper() {
    return (
        <>
            <PageBody>
                <MigratePage />
            </PageBody>
        </>
    )
}
